<template>
  <div class="modal topup-modal">
    <div class="overlay"  @click="$parent.closeTopUpModal"></div>
    <div class="wrapper">
      <div class="container">
        <div>
          <div class="form-wrapper">
            <div class="form-fields" v-if="amountStep">
              <div class="modal-head">
                <img class="close" @click="$parent.closeTopUpModal" src="./../images/close.svg"/>
                <div class="title small">{{ $t('Top Up') }}</div>
              </div>

              <div class="form-fields-wrapper enter-amount">
                <label>
                  <div class="desc">
                    {{ $t('Replenishment amount') }} (1 {{ currencyCode || 'EUR' }} = {{ conversionRate }} RO)
                  </div>
                  <input type="text" @input="allowOnlyNumbers" :placeholder="$t('Enter amount')" v-model="amount"/>
                </label>
                <div v-if="minTopUp" class="desc desc-min">{{ $t('Minimum top-up amount is') }} {{ minTopUpInFiat }} {{ currencyCode || 'EUR' }}</div>
                <div class="buttons">
                  <button class='button button2' @click="$parent.closeTopUpModal">
                      <span>{{ $t('Cancel') }}</span>
                    </button>
                  <button :disabled="!filledMinTopUp" @click="nextStep" :class="['button blue']">
                    <span>{{ $t('Next') }}</span>
                  </button>
                </div>
                <transition name="slide">
                  <div v-if="$parent.error" class="error-desc desc red">{{$parent.error}}</div>
                </transition>
              </div>
            </div>
            <div class="form-fields" v-if="!amountStep">
              <div class="modal-head">
                <img class="close" @click="$parent.closeTopUpModal" src="./../images/close.svg"/>
                <div class="title small">{{ $t('Enter contact information') }}</div>
              </div>

              <div class="form-fields-wrapper contact-info">
                <label>
                  <input type="text" :placeholder="$t('Name')" v-model="name"/>
                </label>
                <label>
                  <input type="text" :placeholder="$t('Surname')" v-model="surname"/>
                </label>
                <label>
                  <input type="email" :placeholder="$t('E-mail address')" v-model="email"/>
                </label>
                <label>
                  <input type="tel" :placeholder="$t('Phone')" v-model="phone"/>
                </label>
                <label>
                  <select v-model="country">
                    <option value="" disabled selected>{{ $t('Country') }}</option>
                    <option v-for="(item, i) in countryOptions" :value="item" :key="i">{{ item.title }}</option>
                  </select>
                </label>
                <label>
                  <input type="text" :placeholder="$t('City')" v-model="city"/>
                </label>
                <label>
                  <input type="text" :placeholder="$t('Address')" v-model="address"/>
                </label>
                <label>
                  <input type="text" :placeholder="$t('Post Code')" v-model="postCode"/>
                </label>
                <div class="cta-container">
                  <div class="chekbox-container">
                    <label class="chekbox-label">
                      <div class="chekbox-label-wrapper">
                        <input type="checkbox" name="terms" v-model="terms"/>
                        <div class="checkbox"></div>
                        <span class="title">{{ $t('I agree with') }} </span>
                        <a @click="goToPrivacy" class="title"> {{ $t('privacy policy') }}</a>
                        <span class="title"> {{ $t('and') }} </span>
                        <a @click="goToTerms" class="title"> {{ $t('terms and conditions') }}</a>
                      </div>
                    </label>
                  </div>
                  <div class="total">
                    <div class="title price">{{ $t('Top Up') }}: {{amount}} {{currencyCode || currencySymbol}} = {{amountInRO}} RO</div>
                  </div>
                    <div class="buttons buttons-pay">
                      <div
                        v-for="(method, idx) in availableTopUpMethods"
                        :key="'pay-method-' + idx"
                        class="method-item flex flex-col items-center"
                      >
                        <button
                          :class="['button', method.buttonClass, {'disabled': !requiredFieldsAreFilled}]"
                          @click="submitWith(method.paymentType, method.id)"
                        >
                          <img
                            v-if="method.image"
                            :src="method.image"
                            :alt="method.title || method.code"
                            class="method-logo"
                          />
                          <span v-else>{{ method.title || method.code }}</span>
                        </button>
                        <div
                          v-if="method.code === 'blik' && $parent && $parent.settings && $parent.settings.visitor_country === 'PL'"
                          style="width: 100%; text-align: center; margin-top: 2px; margin-bottom: 6px;"
                        >
                          <a
                            href="https://www.igoriacard.com/regulamin-i-oplaty/regulamin-BLIK/"
                            target="_blank"
                            class="title blik-link"
                          >{{ $t('BLIK Regulations') }}</a>
                        </div>
                      </div>
                      <div style="width: 100%; grid-column: 1 / -1; margin-top: 4px; display: flex; justify-content: center;">
                        <button class='button button2' style="width: 100%; max-width: 160px;" @click="amountStep = true">
                          <span>{{ $t('Cancel') }}</span>
                        </button>
                      </div>
                    </div>
                  <div v-if="!availableTopUpMethods.length" class="desc red">{{ $t('Payment methods are temporarily unavailable.') }}</div>
                </div>
                <transition name="slide">
                  <div v-if="$parent.error" class="error-desc desc red">{{$parent.error}}</div>
                </transition>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Decimal from 'decimal.js';

export default {
  name: 'TopUpModal',
  props: ['currencyCode', 'currencyValue', 'currencySymbol'],
  components: {
  },
  data: function() {
    return {
      amount: 0,
      amountStep: true,
      email: '',
      name: '',
      surname: '',
      phone: '',
      country: '',
      countryId: '',
      city: '',
      address: '',
      postCode: '',
      terms: false,
      countryOptions: [],
      countryOptionsId: [],
      minTopUp: 0,
      pointsConversionRate: 1
    }
  },
  mounted() {
    this.getCounties();
    this.$http.get(process.env.VUE_APP_API + 'user/profile')
    .then((res) => {
        this.email = res.data.email;
        this.name = res.data.name;
        this.surname = res.data.surname;
        this.phone = res.data.phone;
    })
    .catch((res) => {
      if(res.response.status === 401) {
        this.$parent.openSignIn();
      }
    })
    this.$http.get(process.env.VUE_APP_API + 'settings')
    .then((res) => {
        console.log(res.data.payload.cart_min_amount);
        this.amount = parseInt(res.data.payload.cart_min_amount ? res.data.payload.cart_min_amount : 0);
        this.minTopUp = parseInt(res.data.payload.cart_min_amount);
        this.pointsConversionRate = res.data.payload.points_conversion_rate || 1;
    })
    .catch((res) => {
      if(res.response.status === 401) {
        this.$parent.openSignIn();
      }
    })
  },
  computed: {
    conversionRate() {
      try {
        const currValue = new Decimal(this.currencyValue || 1);
        const pointsRate = new Decimal(this.pointsConversionRate || 1);
        return pointsRate.dividedBy(currValue).toFixed(2);
      } catch (e) {
        return '1.00';
      }
    },
    amountInRO() {
      try {
        if (!this.amount || this.amount === 0) return '0.00';
        const amountDecimal = new Decimal(this.amount);
        const currValue = new Decimal(this.currencyValue || 1);
        const pointsRate = new Decimal(this.pointsConversionRate || 1);
        return amountDecimal.dividedBy(currValue).times(pointsRate).toFixed(2);
      } catch (e) {
        return '0.00';
      }
    },
    minTopUpInFiat() {
      try {
        if (!this.minTopUp || this.minTopUp === 0) return '0.00';
        const minTopUpDecimal = new Decimal(this.minTopUp);
        const currValue = new Decimal(this.currencyValue || 1);
        return minTopUpDecimal.dividedBy(currValue).toFixed(2);
      } catch (e) {
        return '0.00';
      }
    },
    filledMinTopUp() {
      let fieldsAreFilled;

      console.log(this.amount, this.minTopUpInFiat);

      try {
        if (this.minTopUp === undefined || this.minTopUp === null || isNaN(this.minTopUp)) {
          fieldsAreFilled = true;
        } else {
          const amountDecimal = new Decimal(this.amount || 0);
          const minTopUpFiatDecimal = new Decimal(this.minTopUpInFiat || 0);
          fieldsAreFilled = amountDecimal.greaterThanOrEqualTo(minTopUpFiatDecimal);
        }
      } catch (e) {
        fieldsAreFilled = false;
      }

      return fieldsAreFilled;
    },
    requiredFieldsAreFilled() {
      let fieldsAreFilled;
      if(
        this.name && this.surname  && this.phone && 
        this.amount && this.country && 
        this.city && this.address  
        && this.postCode && this.terms 
      ) {
        fieldsAreFilled = true;
      } else {
        fieldsAreFilled = false;
      }
      return fieldsAreFilled;
    },
    configuredPaymentMethods() {
      const settings = this.$parent && this.$parent.settings ? this.$parent.settings : {};
      return settings && Array.isArray(settings.payment_methods) ? settings.payment_methods : [];
    },
    availableTopUpMethods() {
      const methods = this.configuredPaymentMethods;
      if (!methods.length) {
        return [
          { code: 'card', title: 'Cards', image: null, paymentType: 'card', buttonClass: 'blue' },
          { code: 'apple_pay', title: 'Apple Pay', image: null, paymentType: 'apple_pay', buttonClass: 'apple' },
          { code: 'google_pay', title: 'Google Pay', image: null, paymentType: 'google_pay', buttonClass: 'google' },
        ];
      }

      return methods
        .map((item) => {
          if (!item || !item.code) {
            return null;
          }

          return {
            id: item.id || null,
            code: item.code,
            title: item.title,
            image: item.image || null,
            paymentType: item.code,
            buttonClass: this.resolveButtonClass(item.code),
          };
        })
        .filter(Boolean);
    }
  },
  methods: {
    resolveButtonClass(code) {
      const normalized = String(code || '').toLowerCase();
      if (normalized.includes('apple')) return 'apple';
      if (normalized.includes('google')) return 'google';
      return 'blue';
    },
    allowOnlyNumbers(){
      this.amount = this.amount.replace(/[^0-9.,]/g, '');

      // Split the input into integer and decimal parts
      const parts = this.amount.split(/[.,]/);
      const integerPart = parts[0];
      let decimalPart = parts[1];

      // Limit decimal part to two digits
      if (decimalPart !== undefined && decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }

      // Concatenate the integer and decimal parts back
      this.amount = decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;
    },
    getCounties() {
      this.$http.get(process.env.VUE_APP_API + 'countries')
      .then((res) => {
          this.countryOptions = res.data.payload;
      })
      .catch((res) => {
        if(res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      })
    },
    submitWith(method, methodId = null) {
      if (!this.requiredFieldsAreFilled) return;
      let data = {
        "name": this.name,
        "surname": this.surname,
        "phone": this.phone,
        "amount": this.amount,
        "country": this.country.id,
        "city": this.city,
        "address": this.address,
        "postCode": this.postCode,
        "paymentType": method,
        "currency": this.currencyCode
      }
      if (methodId) {
        data.payment_method_id = methodId;
      }
      this.$emit('topUpSubmit', data)
    },
    nextStep() {
      if (this.amount) {
        this.amountStep = false;
        this.$emit('setError', '');
      } else {
        this.$emit('setError', this.$t('Enter amount please'))
      }
    },
    goToTerms() {
      this.$parent.closeTopUpModal();
      this.$parent.goToPage('terms');
    },
    goToPrivacy() {
      this.$parent.closeTopUpModal();
      this.$parent.goToPage('privacy');
    }
  }
}
</script>


<style scoped lang="scss">
//.topup-modal {
//  .form-fields-wrapper {
//    &.contact-info {
//      display: flex;
//      justify-content: space-around;
//      column-gap: 10px;
//
//      label {
//        width: calc(50% - 10px);
//
//        &:nth-child(even) {
//          padding-right: 15px;
//        }
//
//        &:nth-child(odd) {
//          padding-left: 15px;
//        }
//      }
//    }
//  }
//}

//.topup-modal {
//  .form-fields-wrapper {
//    &.contact-info {
//      display: grid;
//      grid-template-columns: repeat(2, 1fr);
//      gap: 20px;
//      justify-content: space-between;
//
//      label {
//        display: block;
//        width: 100%;
//      }
//    }
//  }
//}

/* Local styles for Apple Pay / Google Pay buttons */
.cta-container .buttons-pay .button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-width: 160px;
}

.cta-container .buttons-pay .button .method-logo {
  max-width: 120px;
  max-height: 30px;
  object-fit: contain;
}

/* Apple Pay */
.cta-container .buttons-pay .button.apple {
  //background: #000;
  //border-color: #000;
  padding-top: 3px;
  padding-bottom: 3px;
  color: #fff;
}
.cta-container .buttons-pay .button.apple span::before {
  content: '';
  display: inline-block;
  width: 32px;
  height: 32px;
  background-image: url('../images/apple-pay.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

/* Google Pay */
.cta-container .buttons-pay .button.google {
  //background: #fff;
  //border-color: #dadce0;
  color: #3c4043;
  padding-top: 2px;
  padding-bottom: 2px;
}
.cta-container .buttons-pay .button.google span::before {
  content: '';
  display: inline-block;
  width: 56px;
  height: 34px;
  background-image: url('../images/google-pay.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.topup-modal.modal .wrapper .buttons {
  align-items: flex-start;
}

.topup-modal.modal .wrapper .buttons .button{
  height: 40px;
}

.blik-link {
  text-decoration: none;
  font-size: 12px !important;
  line-height: normal;
}

.blik-link:hover {
  text-decoration: underline;
}
</style>
